import {
	connect
} from 'react-redux'
import CustomerEditComponent from '../components/CustomerEditComponent.jsx';
import {
	changeCustomerValue,
	addCustomer,
	editCustomer
} from '../actions';

const mapStateToProps = (state) => ({
	customer: state.getIn(['customerReducer', 'customer']),
	customerValidation: state.getIn(['customerReducer', 'customerValidation']),
	alertStyle: state.getIn(['customerReducer', 'alertStyle']),
	alertMessage: state.getIn(['customerReducer', 'alertMessage']),
	forInsert: state.getIn(['customerReducer', 'forInsert']),

	activePage: state.getIn(['customerListReducer', 'activePage']),
	itemPerPage: state.getIn(['customerListReducer', 'itemPerPage'])
})

const mapDispatchToProps = (dispatch) => ({
	editItem: (customer, pagingData, forInsert) => {
		if (forInsert) {
			dispatch(addCustomer(customer, pagingData));
		} else {
			dispatch(editCustomer(customer, pagingData));
		}
	},
	setValue: (id, value) => {
		dispatch(changeCustomerValue({
			id: id,
			value: value
		}))
	}
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
	customer: stateProps.customer,
	customerValidation: stateProps.customerValidation,
	alertStyle: stateProps.alertStyle,
	alertMessage: stateProps.alertMessage,
	forInsert: stateProps.forInsert,
	editItem: () => dispatchProps.editItem(stateProps.customer, {
		activePage: stateProps.activePage,
		itemPerPage: stateProps.itemPerPage
	}, stateProps.forInsert),
	setValue: dispatchProps.setValue
})

const CustomerEditContainer = connect(
	mapStateToProps,
	mapDispatchToProps,
	mergeProps
)(CustomerEditComponent)

export default CustomerEditContainer;


// WEBPACK FOOTER //
// ./src/containers/CustomerEditContainer.jsx